import { Component, inject, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MessagesService } from '../../services/messages.service';

@Component({
  selector: 'app-show-message',
  standalone: true,
  imports: [
    MatButtonModule,
    MatDialogActions,
    MatDialogContent,
    MatDialogClose,
    MatIconModule,
  ],
  templateUrl: './show-message.component.html',
  styleUrl: './show-message.component.css'
})
export class ShowMessageComponent {

  readonly dialog = inject(MatDialog);
  @Input() dialogRef: MatDialogRef<ShowMessageComponent> = inject(MatDialogRef);

  constructor(
    public messagesService: MessagesService
  ) { 

  }

}
